import { Component, OnInit } from '@angular/core';
import {   NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginModel } from 'app/_models/login-model';
import { UserModel } from 'app/_models/user-model';
import { AccountService } from 'app/_services/account.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { environment } from 'environments/environment';
import { EncryptionService } from 'app/_services/encryption.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { VersionCheckService } from 'app/_services/version-check.service';
declare const swal: any;
 


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  msg:string;
  model: LoginModel = { username: "", password: "" } as LoginModel;
  currentUser$: Observable<UserModel>;
  hide: boolean = true;
  enable: boolean = false;
  loginForm: NgForm;
  userDto!: UserModel;
  isLoaderResult = false;
  loginHeader:string;
  isPasswordVisible: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly matDialog: MatDialog,
    private readonly accountService: AccountService,
    private readonly toastr: ToastrService,
    private readonly encryptDecryptService: EncryptionService,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    private readonly versionCheckService: VersionCheckService
      ) { }

  ngOnInit() {
    this.versionCheckService.checkVersion();
    this.currentUser$ = this.accountService.currentUser$;
    this.loginHeader = (environment.production? "Login": "Login (Demo)");
    
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
 
 
  handleKeyUp(e){
    if(e.keyCode === 13){
       this.loginBtn();
    }
 }
  
 forgotPassword()
 {
  const dialogRef = this.matDialog.open(ForgotpasswordComponent, {
    width: "400px",
    disableClose: false,
  });
  dialogRef.afterClosed().subscribe((result) => {
    this.ngOnInit();
  });
 }

 loginBtn() {
  this.isLoaderResult = true;

  if (!this.model.username || !this.model.password) {
    this.toastr.error("Invalid Credentials");
    this.msg = "Invalid Credentials";
    this.isLoaderResult = false;
    return;
  }

  this.recaptchaV3Service.execute('login').subscribe((token: string) => {
    const encryptedCredentials = {
      username: this.encryptDecryptService.encrypt(this.model.username),
      password: this.encryptDecryptService.encrypt(this.model.password),
      recaptchaToken: token
    };

    this.accountService.login2(encryptedCredentials).subscribe(response => {
      this.isLoaderResult = false;

      // Wait for the token to be set with retry logic before navigating
      this.accountService.waitForTokenCookie(10, 1000).then(() => {
        console.log('Token found. Navigating to dashboard...');
        this.hideRecaptchaBadge();
        // Now that the token is confirmed to be set, navigate
        this.router.navigateByUrl('/dashboard');
      }).catch(() => {
        // Handle failure to verify token
        console.error('Failed to verify login. Please try again.');
        this.toastr.error("Failed to verify login. Please try again.");
        this.isLoaderResult = false;
      });

    }, (error) => {
      this.isLoaderResult = false;
      
      // Check if it's a network-related issue or a normal error response
      if (error.status === 0) {
        // Handle network-related issues (API down, no internet, etc.)
        swal({
          title: 'Network Error',
          text: 'The server is not reachable. Please check your internet connection or try again later.',
          type: 'error',
          confirmButtonClass: 'btn btn-info'
        });
      } else {
        // Handle specific error responses from the API
        const errorMessage = error.error?.title ?? error.error ?? 'You are not authorized to login. Please try again.';
        swal({
          title: 'Invalid Login Attempt',
          text: errorMessage,
          type: 'error',
          confirmButtonClass: 'btn btn-info'
        });
      }
    });
  }, error => {
    this.isLoaderResult = false;
    this.toastr.error("reCAPTCHA validation failed. Please try again.");
  });
}


waitForUserInSessionStorage(retries: number = 10, delay: number = 1000): Promise<void> {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (sessionStorage['user']) {
        clearInterval(interval);
        resolve();
      } else if (retries-- === 0) {
        clearInterval(interval);
       reject(new Error('User not found in sessionStorage after retries'));
      }
    }, delay);
  });
}


hideRecaptchaBadge() {
  // Dynamically add the CSS to hide the reCAPTCHA badge
  const style = document.createElement('style');
  style.innerHTML = `.grecaptcha-badge { visibility: hidden; }`;
  document.head.appendChild(style);
}

}